module.exports = __webpack_public_path__ + "images/application/illustrations/layouts-ee940a8a.svg";